import { ref } from "vue";
import { queryRoleList, queryRole, updateRole } from "@/api/settings";
import { ElMessage } from "element-plus";

export default function useSettings() {
  const roleList = ref([]);

  const role = ref(null);

  const id = ref(null);

  const loading = ref(true);

  const getRole = () => {
    queryRole({}).then((res) => {
      role.value = res.data.roleId || null;
      id.value = res.data.id || null;
      console.log(typeof id.value, typeof role.value)
      role.value = role.value.toString()
    });
  };

  const getRoleList = () => {
    queryRoleList({}).then((res) => {
      roleList.value = res.data || [];
    });
  };

  const handleSubmit = () => {
    updateRole({
      roleId: role.value,
      id: id.value,
    }).then((res) => {
      if (res.code == 2000) {
        ElMessage.success("操作成功");
        loading.value = true;
      }
    });
  };

  return {
    role,
    roleList,
    loading,
    getRole,
    getRoleList,
    handleSubmit,
  };
}
